import { createStyles } from '@mui/styles';
import { APTheme } from '../../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({
    formSectionContent: {
        marginTop: 20
    },
    changePasswordLink: {
        marginTop: 5,
        padding: '0px'
    },
    formSectionHeader: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        [theme.breakpoints.down('md')]: {
            alignItems: 'flex-start',
            flexDirection: 'column'
        }
    },
    formSectionHeading: {
        fontWeight: 500
    },
    formSectionInput: {
        marginBottom: 25,
        width: '100%',
        '@media(max-width: 480px)': {
            marginBottom: 20,
        },
        '&:last-child': {
            marginBottom: 0
        }
    },
    currentPasswordInput: {
        marginBottom: 0
    },
});